export default __webpack_public_path__ + "static/media/newAdd.ae699a2c.svg";